import {useEffect, useRef, useState} from "react";
import {imgs} from "../../utils/image";
import {isNotEmpty} from "../../utils/strings";
import {url} from "../../utils/urls";
import {fetchPost} from "../../utils/fetch";
import {popErrors} from "../../utils/message";
import {isEmptyList} from "../../utils/objects";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import {stopEvent} from "../../utils/events";

import "../../../style/common/slider/_slider.scss";
import StarItem from "../favorites/StarItem";
import {Link, useNavigate} from "react-router-dom";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperArrowLeft from "../slider/SwiperArrowLeft";
import SwiperArrowRight from "../slider/SwiperArrowRight";

const GoodsHistoryView = (
  {
    data = {},
  }) => {
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const searching = useRef(false);

  const [goodsList, setGoodsList] = useState([]);

  const [swiperState, setSwiperState] = useState({});
  const [sliderEnd, setSliderEnd] = useState(true);
  const [sliderBeginning, setSliderBeginning] = useState(true);


  const navigate = useNavigate();

  const search = ({
                    callSuccess = () => {},
                    callError = () => {},
                    callComplete = () => {},
                  }) => {
    if(searching.current) {
      return;
    }
    searching.current = true;

    setSearchLoading(true);
    let conditionData = {max_count: data["maxCount"]};
    fetchPost({
      action: url("/api/list/search/history"),
      data: conditionData
    })
      .then((result) => {
        // 商品一覧
        setGoodsList(result["goods_list"]);
        callSuccess()
      })
      .catch((reason) => {
        popErrors(reason);
        callError(reason);
      })
      .finally(() => {
        // ページローディング終了
        setSearchLoading(false);
        searching.current = false;
        callComplete();
      });
  };


  useEffect(() => {
    if (!loading) {
      return;
    }
    // 検索実行
    search({
      callComplete : () => {
        setLoading(false);
      }
    });

  }, [loading]);

  const handleClickGoods = (e, goodsCode) => {
    navigate("/goods/" + goodsCode + "/");
    stopEvent(e);
  }

  const getImagePath = (path, width, height) => {
    return imgs(
      path,
      isNotEmpty(width) ? width : 750,
      isNotEmpty(height) ? height : 0
    );
  }
  return (
    ((loading || searchLoading) ?
      <>
        <div className="placeholder-glow" style={data.style}>
          <div className="col-12 placeholder"></div>
        </div>
      </>
      :
      (!isEmptyList(goodsList) ?
        <div className={"history-container " + data["attr"]["className"]} style={data.style}>
          {/*全体タイトル*/}
          <div className="slider-title text-start com-title">
            <div className="title1">{data["title1"]}</div>
            <div className="title2">{data["title2"]}</div>
            <SwiperArrowLeft swiper={swiperState} isEnabled={sliderBeginning} />
            <SwiperArrowRight swiper={swiperState} isEnabled={sliderEnd} />

          </div>
          {/*一覧スライダー*/}
          <div className="slider-view-container" >
            <Swiper
              onSwiper={(swiper) => {
                setSwiperState(swiper);
                setSliderEnd(swiper.isEnd);
                setSliderBeginning(swiper.isBeginning);
              }}
              onSlideChange={(swiper) => {
                setSliderEnd(swiper.isEnd);
                setSliderBeginning(swiper.isBeginning);
              }}
              navigation={false}
              slidesPerView={isNotEmpty(data["minCol"]) ? data["minCol"]: "auto"}
              loop={false}
              spaceBetween={5}
              breakpoints={{
                1300: {
                  slidesPerView: isNotEmpty(data["maxCol"]) ? data["maxCol"] : "auto",
                }
              }}

            >
              {goodsList.map((goods) =>
                <SwiperSlide className="" key={"hist_" + goods.goods_code}>
                  <Link href={"/goods/" + goods.goods_code + "/"} onClick={(e) => {handleClickGoods(e, goods.goods_code)}}>
                    {/*画像*/}
                    <div className="pho zoom">
                      <LazyLoadImage
                        className="img-fluid"
                        src={getImagePath(goods["image_path01"], data.imageWidth, data.imageHeight)}
                        effect="opacity"
                        alt={goods["goods_name"]}/>
                      {/*お気に入り*/}
                      <StarItem goodsData={goods} />
                    </div>
                    {/*商品名*/}
                    {/*<div className="title">{goods["goods_name"]}</div>*/}
                  </Link>
                </SwiperSlide>
              )}
            </Swiper>
          </div>
        </div>
        :
        // 一見も存在しない場合は空白にする
        <></>
      )
    )
  )
};

export default GoodsHistoryView;